import React from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import FormOriginal from "./form";
function Create(props) {
  const handleSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        Axios.post(baseUrl + "products", {
          name: values.name,
          macId: values.macId,
          components: values.components,
          bannerImage: values.bannerImage,
          companyLogo: values.companyLogo
        }).then(response => console.log(response));
      }
    });
  };

  return (
    <div style={{ justifyContent: "center" }}>
      <h3 style={{ textAlign: "center" }}>Create New Active Product</h3>
      <FormOriginal handleSubmit={handleSubmit} type="Create" />
    </div>
  );
}

export default Create;
